/**
 * @generated SignedSource<<eb686d7b18b5c2f4c58a5265e50e70a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameSupplierInput = {
  id: string;
  name: string;
};
export type SuppliersViewRenameMutation$variables = {
  input: RenameSupplierInput;
};
export type SuppliersViewRenameMutation$data = {
  readonly renameSupplier: {
    readonly id: string;
    readonly name: string;
  };
};
export type SuppliersViewRenameMutation = {
  response: SuppliersViewRenameMutation$data;
  variables: SuppliersViewRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "renameSupplier",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SuppliersViewRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuppliersViewRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "564991887ca6065b716a192578cbf5c3",
    "id": null,
    "metadata": {},
    "name": "SuppliersViewRenameMutation",
    "operationKind": "mutation",
    "text": "mutation SuppliersViewRenameMutation(\n  $input: RenameSupplierInput!\n) {\n  renameSupplier(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "49a5eadda7be98fedbbf6676ff81d2dd";

export default node;
